import { forwardRef, type Ref, type SVGProps } from "react";
const IconExternalFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M30 4.001a2 2 0 0 0-2-2h-8a2 2 0 1 0 0 4h3.172L12.5 16.671a2 2 0 0 0 2.828 2.83L26 8.83v3.172a2 2 0 0 0 4 0z"
    />
    <path
      fill="currentColor"
      d="M12 8H6v18h18v-5a2 2 0 0 1 4 0v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h7a2 2 0 1 1 0 4"
    />
  </svg>
);
const ForwardRef = forwardRef(IconExternalFilledSVG);
ForwardRef.displayName = "IconExternalFilled";
export { ForwardRef as IconExternalFilled };
